<template>
  <div class="box2">
    <pageTitle
      title="谁掌握了数据分析 谁就掌握了未来! "
      text="从IT时代到DT（Data Technology）数据时代，数据浪潮势不可<br/>挡，已经没有【不产生数据、绝对不需要分析数据】的行业。"
      titleColor="#24375C"
      titColor="#86909C"
    />

    <div class="nav-box">
      <div
        class="nav"
        v-for="(item, index) in navList"
        :key="index"
        :class="[index == cur ? 'activeNav' : '']"
        @click="goSwiper(index)"
      >
        <p>{{ item }}</p>
      </div>
    </div>

    <div class="content-box">
      <swiper
        :options="swiperOption1"
        ref="swiperOption1"
        @slideChange="slideChange()"
      >
        <swiper-slide
          class="swiper-slides"
          v-for="(i, index) in list"
          :key="i + Math.random()"
          :class="`slide${index}`"
        >
          <div class="block">
            <div class="titleBox">
              <div class="icon"></div>
              <div class="title">{{ i.title }}</div>
              <div class="icon"></div>
            </div>
            <div class="desc">{{ i.p }}</div>

            <div v-if="i.itemList.length > 1">
              <swiper :options="swiperOption2">
                <swiper-slide v-for="k in i.itemList" :key="k + Math.random()">
                  <img class="bannerImg" :src="k.img" alt />
                  <p class="txt1">{{ k.txt1 }}</p>
                </swiper-slide>
              </swiper>
              <!-- <div class="swiper-pagination-boxtwo"></div> -->
            </div>

            <div v-else>
              <img class="img" :src="i.itemList[0].img" alt />
              <p class="p1">
                {{ i.itemList[0].txt1 }}
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <!-- <div
        class="swiper-pagination-boxone"
        v-show="list[cur].itemList.length != 1"
      ></div> -->
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  computed: {
    cSwiper() {
      return this.$refs.swiperOption1.swiper;
    },
  },
  data() {
    return {
      activeIndex: 0,
      swiperOption1: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 50,
        pagination: {
          el: ".swiper-pagination-boxone",
        },
      },
      swiperOption2: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 50,
        autoplay: {
          delay: 3000, // 自动播放的时长
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination-boxtwo",
        },
      },
      cur: 0,
      navList: ["缺口大", "薪资高", "范围广", "周期长"],
      list: [
        {
          title: "人才缺口大",
          p: "在2022-2023年全球及中国互联网人才需求排行榜中，【数据分析员】跻身TOP5！2023年2月一线及新一线城市的数据分析人才招聘缺口71万+ ！",

          itemList: [
            {
              txt1: "数据来源：领英才大数据洞察",
              img: require("../../../assets/coursePage/dataAnalysis/box2/1.1.png"),
            },
            {
              txt1: "数据来源：职友集，2023年2月数据",
              img: require("../../../assets/coursePage/dataAnalysis/box2/1.2.png"),
            },
          ],
        },
        {
          title: "行业薪资高",
          p: "数据显示：全国数据分析师月均可达工资2.4W+，且不少大厂月均可达4W+，买房买车指日可待！",
          itemList: [
            {
              txt1: "数据来源：看准网，2023年2月14日采集",
              img: require("../../../assets/coursePage/dataAnalysis/box2/2.1.png"),
            },
            {
              txt1: "数据来源：看准网，2023年2月14日采集",
              img: require("../../../assets/coursePage/dataAnalysis/box2/2.2.png"),
            },
          ],
        },
        {
          title: "应用范围广",
          p: "数据时代各行各业都离不开数据，数据分析师正逐渐成为各大企业的核心岗位。 ",
          itemList: [
            {
              img: require("../../../assets/coursePage/dataAnalysis/box2/3.1.png"),
            },
          ],
        },
        {
          title: "职业周期长",
          p: " 数据分析受年龄、行业等外部因素相对较小，职位相对稳定，经验导向、越老越“吃香”。",
          itemList: [
            {
              txt1: "数据来源：各主流招聘网站招聘信息",

              img: require("../../../assets/coursePage/dataAnalysis/box2/4.1.png"),
            },
          ],
        },
      ],
    };
  },

  methods: {
    slideChange() {
      this.cur = this.$refs.swiperOption1.$el.swiper.realIndex;
    },
    goSwiper(index) {
      this.cSwiper.slideTo(index, 0);
      this.cur = index;
    },
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 204px 0 40px;

  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box2/bgc.png")
    no-repeat;
  background-size: cover;
  position: relative;
  width: 750px;
  overflow: hidden;
  .swiper-container {
    overflow: visible;
  }
  .nav-box {
    display: flex;
    justify-content: center;
    margin: 48px 0;
    .nav {
      width: 138px;
      height: 68px;
      background: #ffffff;
      border-radius: 8px;
      margin-right: 20px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 68px;
      text-align: center;
    }
    .nav:last-child {
      margin-right: 0;
    }
    .activeNav {
      background: linear-gradient(224deg, #6aacfd 0%, #6a89f1 100%);
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 68px;
    }
  }
  .content-box {
    position: relative;

    .swiper-slides {
      width: 690px;
      padding-bottom: 48px;
      //height: 802px;
    }
  }
  .block {
    width: 686px;
    height: 856px;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 8px 30px 0px #d9eefb;
    border: 2px solid #ffffff;
    backdrop-filter: blur(5px);
    border-radius: 15px;
    box-sizing: border-box;
    overflow: hidden;
    .box {
      height: 24px;
    }
    .titleBox {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 32px 0 16px;
      .icon {
        background: url("../../../assets/coursePage/dataAnalysis/box2/titleIcon.png")
          no-repeat;
        background-size: cover;
        width: 32px;
        height: 32px;
      }
      .title {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
        padding: 0 8px;
      }
    }
    .desc {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1d2129;
      line-height: 40px;
      padding: 0 32px;
      margin-bottom: 32px;
      text-align: center;
    }
    img {
      display: block;
      width: 646px;
      height: 524px;
      background: #f4f6ff;
      border-radius: 10px;
      padding: 26px 32px 32px;
      box-sizing: border-box;
      display: block;
      margin: 0 auto;
    }
    p:nth-child(4) {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #665552;
      line-height: 40px;
      padding: 0 40px;
      box-sizing: border-box;
    }
    p:nth-child(5) {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #cbb3af;
      line-height: 32px;
      margin-top: 16px;
      padding: 0 40px;
      box-sizing: border-box;
    }
  }
  .swiper-pagination-boxone {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: #ffab9a;
    border-radius: 3px;

    z-index: 99;
    /deep/ .swiper-pagination-bullet {
      width: 20px;
      height: 6px;
      background: #ffab9a;
      border-radius: 3px;
    }

    /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
      width: 20px;
      height: 6px;
      background: #ff5731;
      border-radius: 3px;
    }
  }

  .swiper-pagination-boxtwo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 6px;

    border-radius: 3px;
    position: absolute;
    bottom: 0px;
    right: 37px;
    z-index: 99;
    /deep/ .swiper-pagination-bullet {
      width: 16px;
      height: 6px;
      background: #c7cef1;
      border-radius: 3px;
      margin-right: 4px;
      margin-left: 4px;
      opacity: 1;
    }

    /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
      width: 16px;
      height: 6px;
      background: #364eff;
      border-radius: 3px;
    }
  }
  .txt1 {
    width: 100%;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #86909c;
    line-height: 36px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -53px;
    text-align: center;
  }
  .slide1 {
    .bannerImg {
      height: 564px;
      padding: 32px 32px 38px 32px;
    }
  }
  .slide2 {
    .img {
      height: 564px;
      padding: 32px 32px 32px 32px;
    }
  }
  .slide3 {
    .img {
      height: 564px;
      padding: 32px 32px 32px 32px;
    }
  }
  .p1 {
    font-size: 20px !important;
    font-family: PingFangSC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #86909c !important;
    line-height: 36px !important;
    width: 100%;
    text-align: center;
    margin-top: 16px;
  }
}
</style>
